import React from 'react';
import ESIInclude from '../../esi';
import { HeaderWrapper } from '../components/header-wrapper/HeaderWrapper';
import { EnvVarsFeaturesContext } from './EnvVarsFeaturesContext';
import { UserContextProvider } from '../scaffold/UserContext';

export class HeaderApp extends React.Component {
  constructor(props) {
    super();
    const {
      envVars = {},
      features = {},
      categories = {},
      headerClientConfigQueryParameters = {},
      query = {},
      notificationBannerFolder = '',
      fallbackMenu = '',
      columnHighlighted = '',
      mobileBoostWishlist = '',
      stickySearchDesktop = '',
    } = props.initialState;
    this.envVars = envVars;
    this.features = features;
    this.categories = categories;
    this.headerClientConfigQueryParameters = headerClientConfigQueryParameters;
    this.query = query;
    this.notificationBannerFolder = notificationBannerFolder;
    this.fallbackMenu = fallbackMenu;
    this.columnHighlighted = columnHighlighted;
    this.mobileBoostWishlist = mobileBoostWishlist;
    this.stickySearchDesktop = stickySearchDesktop;
  }

  render() {
    return (
      <div>
        <ESIInclude
          id="experimentation-esi"
          src="/esi/experimentation/page-load-experiments"
          data-testid="experimentation-esi"
        />
        <UserContextProvider>
          <EnvVarsFeaturesContext.Provider
            value={{
              envVars: this.envVars,
              features: this.features,
              categories: this.categories,
              headerClientConfigQueryParameters:
                this.headerClientConfigQueryParameters,
              query: this.query,
              fallbackMenu: this.fallbackMenu,
              columnHighlighted: this.columnHighlighted,
              mobileBoostWishlist: this.mobileBoostWishlist,
              stickySearchDesktop: this.stickySearchDesktop,
            }}
          >
            <HeaderWrapper features={this.features} />
            {this.notificationBannerFolder ? (
              <ESIInclude
                id="header-notification-banner"
                src={`/${this.envVars.bannerPath}/${this.notificationBannerFolder}/index.html`}
                data-testid="header-notification-banner"
              />
            ) : (
              ''
            )}
          </EnvVarsFeaturesContext.Provider>
        </UserContextProvider>
      </div>
    );
  }
}

HeaderApp.displayName = 'HeaderApp';
